const comparisons = [
  {
    feature: 'Time to Launch',
    ai: 'Days',
    traditional: 'Weeks to Months',
    highlight: true,
  },
  {
    feature: 'Starting Cost',
    ai: 'From $1,000',
    traditional: '$3,000 – $15,000+',
    highlight: false,
  },
  {
    feature: 'Custom Built',
    ai: '100% — every time',
    traditional: 'Often template-based',
    highlight: true,
  },
  {
    feature: 'Design Quality',
    ai: 'Modern, professional',
    traditional: 'Varies widely',
    highlight: false,
  },
  {
    feature: 'Revisions',
    ai: 'Included & fast',
    traditional: 'Often billed hourly',
    highlight: false,
  },
  {
    feature: 'Local SEO',
    ai: 'Built in from day 1',
    traditional: 'Often an add-on',
    highlight: false,
  },
  {
    feature: 'Ongoing Support',
    ai: 'Flat monthly fee',
    traditional: 'Hourly retainers',
    highlight: false,
  },
];

export default function AIvsTraditional() {
  const scrollToContact = () => {
    const el = document.getElementById('contact');
    if (el) el.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <section id="ai-vs-traditional" className="py-20 lg:py-32 bg-black">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12 lg:mb-16">
          <div className="inline-block px-4 py-2 bg-white/5 border border-white/10 rounded-full mb-6">
            <span className="text-sm text-gray-300 font-medium">AI vs Traditional Web Development</span>
          </div>
          <h2 className="text-3xl sm:text-4xl lg:text-6xl font-bold text-white mb-6">
            AI Web Development vs Traditional Agencies
          </h2>
          <p className="text-base sm:text-xl text-gray-400 max-w-3xl mx-auto">
            Nashville small businesses deserve fast, professional websites without the bloated agency price tags. See why AI-powered web development is the smarter choice for local businesses.
          </p>
        </div>

        {/* Scrollable table wrapper */}
        <div className="overflow-x-auto mb-12 rounded-3xl border border-white/10">
          <div className="min-w-[480px] bg-gray-950">
            {/* Header */}
            <div className="grid grid-cols-3 bg-black border-b border-white/10">
              <div className="p-4 sm:p-6 text-xs sm:text-sm uppercase tracking-widest text-gray-500 font-semibold"></div>
              <div className="p-4 sm:p-6 text-center border-l border-white/10">
                <div className="flex items-center justify-center gap-1 sm:gap-2 mb-1">
                  <div className="w-4 h-4 sm:w-5 sm:h-5 flex items-center justify-center">
                    <i className="ri-robot-line text-white text-sm sm:text-base"></i>
                  </div>
                  <span className="text-white font-bold text-sm sm:text-lg">GWDevelopers</span>
                </div>
                <span className="text-xs text-gray-400">AI-Powered · Nashville</span>
              </div>
              <div className="p-4 sm:p-6 text-center border-l border-white/10">
                <div className="flex items-center justify-center gap-1 sm:gap-2 mb-1">
                  <div className="w-4 h-4 sm:w-5 sm:h-5 flex items-center justify-center">
                    <i className="ri-building-2-line text-gray-500 text-sm sm:text-base"></i>
                  </div>
                  <span className="text-gray-400 font-bold text-sm sm:text-lg">Traditional</span>
                </div>
                <span className="text-xs text-gray-500">Old-school process</span>
              </div>
            </div>

            {comparisons.map((row, index) => (
              <div
                key={index}
                className={`grid grid-cols-3 border-b border-white/5 last:border-b-0 ${row.highlight ? 'bg-white/5' : ''}`}
              >
                <div className="p-4 sm:p-6 text-gray-300 font-medium text-sm sm:text-base">{row.feature}</div>
                <div className="p-4 sm:p-6 text-center border-l border-white/5">
                  <span className="text-white font-semibold text-sm sm:text-base">{row.ai}</span>
                </div>
                <div className="p-4 sm:p-6 text-center border-l border-white/5">
                  <span className="text-gray-500 text-sm sm:text-base">{row.traditional}</span>
                </div>
              </div>
            ))}
          </div>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-3 gap-6 sm:gap-8 mb-12">
          <div className="bg-gray-950 border border-white/10 rounded-2xl p-6 sm:p-8 text-center">
            <div className="text-4xl sm:text-5xl font-bold text-white mb-2">10x</div>
            <div className="text-gray-400 text-sm">Faster than traditional development</div>
          </div>
          <div className="bg-gray-950 border border-white/10 rounded-2xl p-6 sm:p-8 text-center">
            <div className="text-4xl sm:text-5xl font-bold text-white mb-2">70%</div>
            <div className="text-gray-400 text-sm">Lower cost than traditional agencies</div>
          </div>
          <div className="bg-gray-950 border border-white/10 rounded-2xl p-6 sm:p-8 text-center">
            <div className="text-4xl sm:text-5xl font-bold text-white mb-2">100%</div>
            <div className="text-gray-400 text-sm">Custom-built — never a template or reused design</div>
          </div>
        </div>

        <div className="text-center">
          <button
            onClick={scrollToContact}
            className="px-8 sm:px-10 py-4 bg-white text-black font-bold rounded-lg hover:bg-gray-200 transition-all duration-300 whitespace-nowrap cursor-pointer"
          >
            Get a Free Demo Website
          </button>
        </div>
      </div>
    </section>
  );
}
